import { useGroup, useGroupEnd, useLogError } from "./useLog.mjs";
import usePixelMeta from "./usePixelMeta.mjs";
import usePixelReddit from "./usePixelReddit.mjs";
import usePixelGoogle from "./usePixelGoogle.mjs";
import useConsent from "./useConsent.mjs";
import {
  metaToRedditEventNames,
  metaToRedditUserData,
  metaToGoogleEventNames
} from "../consts/eventNames.mjs";
export default function() {
  const { haveConsent } = useConsent();
  const metaPixel = usePixelMeta();
  const redditPixel = usePixelReddit();
  const googlePixel = usePixelGoogle();
  const init = () => {
    if (!haveConsent.value)
      return;
    useGroup("init all pixels");
    metaPixel.init();
    redditPixel.init();
    googlePixel.init();
    useGroupEnd();
  };
  const track = (eventName, params) => {
    if (!haveConsent.value)
      return;
    useGroup("track with all pixels");
    metaPixel.track(eventName, params);
    redditPixel.track(
      eventName ? metaToRedditEventNames[eventName] || eventName : eventName,
      params
    );
    googlePixel.track(
      eventName ? metaToGoogleEventNames[eventName] || eventName : eventName,
      params
    );
    useGroupEnd();
  };
  const cleanMetaInput = (input, type = "reddit") => {
    const output = {};
    let metaTo;
    if (type === "reddit") {
      metaTo = metaToRedditUserData;
    } else {
      useLogError("cleanMetaInput has not account for type", type);
      return;
    }
    for (const el in input) {
      if (metaTo[el]) {
        output[metaTo[el]] = input[el];
      }
    }
    return output;
  };
  const setUserData = (input, initPixel = true) => {
    if (!haveConsent.value)
      return;
    useGroup("set userdata for all pixels");
    metaPixel.setUserData(input, initPixel);
    redditPixel.setUserData(cleanMetaInput(input));
    useGroupEnd();
  };
  return {
    track,
    init,
    setUserData
  };
}
